import { Component } from '@angular/core';

@Component({
  selector: 'app-forbidden',
  template: `
    <section class="page">
      <h1>403 — Forbidden</h1>
      <p>You don't have permission to view this page.</p>
      <a routerLink="/cases">Back to cases</a>
    </section>
  `,
  styles: [`
    .page { padding: 48px; max-width: 600px; margin: 0 auto; }
    h1 { color: var(--primary); }
  `],
  standalone: false,
})
export class ForbiddenComponent {}
